module.exports = __webpack_public_path__ + "img/head.7635f7e6.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/head.jpeg
// module id = tYe/
// module chunks = 1